import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DCCheckboxComponent } from './checkbox.component';



@NgModule({
  declarations: [
    DCCheckboxComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DCCheckboxComponent
  ]
})
export class DCCheckboxModule { }
